// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__4Y4Ir","rootSuccess":"CompleteLink_rootSuccess__1czW2","rootFailure":"CompleteLink_rootFailure__1Ifv7","isDisabled":"CompleteLink_isDisabled__1oDiL"};